import isNil from "lodash.isnil";
import { qs } from "scripts/data_utils/domHelpers";

function changeHeight(el, num) {
  el.style.height = `${num}px`;
}

const mobileAdoptedPage = ["^/$", "^/about/$", "^/books/*", "^/offer/$", "^/privacy/$", "^/domains/$", "^/services/$", "^/services/proofread/$", "^/feedback/$", "^/services-offer/$", "^/statistics/$", "^/account/profile/$", "^/ebukva/$", "^/orders/promotion/$", "^/agreement/$", "^/orders/$"];
const desktopBreakpoint = 1140;

function toggleMobileView(targetElement = {}) {
  const {
    target: {
      innerWidth: windowWidth
    } = window
  } = targetElement;
  const [bodyElement] = document.getElementsByTagName("body");
  const currentPathname = window.location.pathname;
  let isAdaptedPage = false;

  for (const page of mobileAdoptedPage) {
    isAdaptedPage = new RegExp(page).test(currentPathname);

    if (isAdaptedPage) {
      break;
    }
  }

  if (!isAdaptedPage || windowWidth > desktopBreakpoint) {
    bodyElement.classList.remove("mobile");
  } else {
    bodyElement.classList.add("mobile");
  }
}

function toggleMobileMenu(event) {
  event.stopPropagation();
  const buttonIcon = qs(".js-navigation-icon", event.currentTarget);
  buttonIcon.classList.toggle("navigation__trigger-icon--open");
  const bodyElement = qs("body");
  bodyElement.classList.toggle("mobile--active");
}

function initMobileNavigationDrawer() {
  const mobileMenuTrigger = qs(".js-overlay-trigger");

  if (mobileMenuTrigger) {
    mobileMenuTrigger.addEventListener("click", toggleMobileMenu);
  }

  toggleMobileView();
  window.addEventListener("resize", toggleMobileView);
}

async function initGlobalMenu(userData) {
  const menu = qs(".js-global-nav");

  if (menu) {
    const menuInner = qs(".js-menu-open", menu);
    menu.addEventListener("mouseenter", () => {
      menuInner && changeHeight(menuInner, menuInner.scrollHeight + 20);
    });
    menu.addEventListener("mouseleave", () => {
      menuInner && changeHeight(menuInner, 0);
    });
    const {
      books_by_status: booksByStatus
    } = userData;

    const findByBookStatus = (booksStatusList, statusName) => {
      const requiredElement = booksStatusList.filter(({
        status
      }) => status === statusName);

      if (requiredElement.length < 1) {
        return null;
      }

      return requiredElement;
    };

    const [booksInRejectedStatus] = findByBookStatus(booksByStatus, "rejected");

    if (isNil(booksInRejectedStatus)) {
      throw new Error("An error occurred while trying to get the number of books in rejected status. Api - /api/account/info/my/");
    }

    const {
      count: countBookInRejectedStatus
    } = booksInRejectedStatus;

    if (Number(countBookInRejectedStatus) > 0) {
      const targets = [...document.querySelectorAll('[data-target="nav_my-books"]')];

      if (targets.length === 0) {
        return;
      }

      targets.forEach(item => {
        const dotMarker = document.createElement("span");
        dotMarker.classList.add("item__book-status-indicator");
        item.appendChild(dotMarker);
      });
    }
  }
}

export { initGlobalMenu as default, initMobileNavigationDrawer };